// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InfoTooltip__trigger":"bca_a bhr_jb bhr_qx bhr_eg"};